import { SignIn } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const signInSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/sign-in/$")({
  validateSearch: signInSearchSchema,
  component: SignInPage,
});

function SignInPage() {
  const { redirect } = Route.useSearch();
  const fallback = "/sites";
  const target = redirect?.startsWith("/") ? redirect : fallback;
  // Use fallbackRedirectUrl, NOT forceRedirectUrl: when Clerk acts as an OIDC
  // provider it sends the operator here mid-OAuth with a ?redirect_url back to
  // its consent page. forceRedirectUrl would override that and strand the user
  // on /sites, breaking the brokered CLI login. fallbackRedirectUrl lets Clerk's
  // redirect_url win when present, and still honors our own ?redirect / default.
  return (
    <div className="min-h-dvh grid place-items-center bg-background p-6">
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" fallbackRedirectUrl={target} />
    </div>
  );
}
